/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_Sign_In_NoticeInputs */

const en_common_support_sign_in_notice = /** @type {(inputs: Common_Support_Sign_In_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please sign in to submit a support ticket.`)
};

const zh_common_support_sign_in_notice = /** @type {(inputs: Common_Support_Sign_In_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先登录后再提交工单。`)
};

/**
* | output |
* | --- |
* | "Please sign in to submit a support ticket." |
*
* @param {Common_Support_Sign_In_NoticeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_sign_in_notice = /** @type {((inputs?: Common_Support_Sign_In_NoticeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_Sign_In_NoticeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_sign_in_notice(inputs)
	return zh_common_support_sign_in_notice(inputs)
});
export { common_support_sign_in_notice as "common.support.sign_in_notice" }